import { render, staticRenderFns } from "./DeletePackage.vue?vue&type=template&id=76d34970&"
import script from "./DeletePackage.vue?vue&type=script&lang=js&"
export * from "./DeletePackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports